import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-12 col-lg-6" };
const _hoisted_9 = { class: "input-group" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "col-12 mt-3 mb-2" };
const _hoisted_12 = { class: "clearfix" };
const _hoisted_13 = { class: "btn-group pw100 bottom10" };
const _hoisted_14 = { class: "row left-10 right-10" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = { class: "input-group top_search" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_20 = { class: "font-weight-normal" };
const _hoisted_21 = { class: "checkbox-wrapper" };
const _hoisted_22 = { class: "bottom10" };
const _hoisted_23 = {
    key: 1,
    class: "bottom10"
};
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "col-12 col-lg-6" };
const _hoisted_26 = { class: "col-12" };
const _hoisted_27 = { class: "col-12" };
const _hoisted_28 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _cache[14] || (_cache[14] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[55] || (_cache[55] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All companies",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[56] || (_cache[56] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All sites",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[57] || (_cache[57] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "System", -1 /* CACHED */)),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.system,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.system) = $event)),
                    options: _ctx.systemsFiltered,
                    "track-by": "systemId",
                    label: "displayName",
                    showLabels: false,
                    placeholder: _ctx.selectPlaceholderSystem,
                    "allow-empty": false,
                    class: _normalizeClass([_ctx.isSystemInvalid ? 'is-invalid' : ''])
                }, {
                    noResult: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options", "placeholder", "class"])
            ]),
            _cache[41] || (_cache[41] = _createTextVNode()),
            (_ctx.displayAdvancedFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_b_form_radio, {
                            modelValue: _ctx.periodType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.periodType) = $event)),
                            name: "period-radio",
                            value: "1"
                        }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("Baseline to latest reading", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"]),
                        _cache[29] || (_cache[29] = _createTextVNode()),
                        _createVNode(_component_b_form_radio, {
                            modelValue: _ctx.periodType,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.periodType) = $event)),
                            name: "period-radio",
                            value: "2"
                        }, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("Period", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"]),
                        _cache[30] || (_cache[30] = _createTextVNode()),
                        _withDirectives(_createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                        title: _ctx.getPeriodTitle(item)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick", "title"])), [
                                        [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            { hover: true }
                                        ]
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                                [_vShow, !_ctx.showDatePickers]
                            ]),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _withDirectives(_createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.startTime,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.startTime) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Select date"
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _cache[23] || (_cache[23] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                        _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _cache[27] || (_cache[27] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.endTime,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.endTime) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Select date"
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _cache[26] || (_cache[26] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[25] || (_cache[25] = _createTextVNode()),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[7] || (_cache[7] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ], 512 /* NEED_PATCH */), [
                                [_vShow, _ctx.showDatePickers]
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.periodType == 2]
                        ])
                    ]),
                    _cache[36] || (_cache[36] = _createTextVNode()),
                    _cache[37] || (_cache[37] = _createElementVNode("label", null, "Strings Selection", -1 /* CACHED */)),
                    _cache[38] || (_cache[38] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_multiselect, {
                            ref: "stringsList",
                            id: "strings-list",
                            name: "strings-list",
                            options: _ctx.stringsList,
                            multiple: true,
                            showLabels: false,
                            "preserve-search": true,
                            "close-on-select": false,
                            placeholder: "",
                            "track-by": "value",
                            label: "text",
                            class: "multiselect-small",
                            disabled: _ctx.working
                        }, {
                            noResult: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            placeholder: _withCtx(() => [
                                (!_ctx.numberOfSelectedStringToExport)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "\r\n\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t"))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            selection: _withCtx(({ search, isOpen }) => [
                                (_ctx.numberOfSelectedStringToExport && !isOpen)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.stringToExportOptionText), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            option: _withCtx((props) => [
                                _createElementVNode("div", null, [
                                    _createVNode(_component_b_form_checkbox, {
                                        id: 'string-' + props.option.value,
                                        modelValue: props.option.selected,
                                        "onUpdate:modelValue": ($event) => ((props.option.selected) = $event)
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("label", _hoisted_20, _toDisplayString(props.option.text), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["options", "disabled"])
                    ]),
                    _cache[39] || (_cache[39] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.hidePredictionColumn,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.hidePredictionColumn) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                    _createTextVNode("\r\n\t\t\t\t\tHide Prediction column\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[40] || (_cache[40] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", {
                            class: "blue",
                            href: "#",
                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.displayAdvancedFilter = false))
                        }, "Hide advanced parameters")
                    ])
                ]))
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("a", {
                        class: "blue",
                        href: "#",
                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.displayAdvancedFilter = true))
                    }, "Show advanced parameters")
                ], 512 /* NEED_PATCH */)), [
                    [_vShow, !_ctx.displayAdvancedFilter]
                ])
        ]),
        _cache[58] || (_cache[58] = _createTextVNode()),
        (_ctx.displayAdvancedFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                    _cache[48] || (_cache[48] = _createElementVNode("h5", null, "Limits", -1 /* CACHED */)),
                    _cache[49] || (_cache[49] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_26, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", null, "\r\n\t\t\t\t\tTotal Ohmic Rise Limit (%)\r\n\t\t\t\t", -1 /* CACHED */)),
                        _cache[43] || (_cache[43] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.totalOhmicRiseLimit,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.totalOhmicRiseLimit) = $event)),
                            modelModifiers: { trim: true },
                            min: "0",
                            max: "100",
                            step: "1"
                        }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[50] || (_cache[50] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_27, [
                        _cache[44] || (_cache[44] = _createElementVNode("label", null, "\r\n\t\t\t\t\tQuarter Ohmic Rise Limit (%)\r\n\t\t\t\t", -1 /* CACHED */)),
                        _cache[45] || (_cache[45] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.quarterOhmicRiseLimit,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.quarterOhmicRiseLimit) = $event)),
                            modelModifiers: { trim: true },
                            min: "0",
                            max: "100",
                            step: "1"
                        }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[51] || (_cache[51] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_28, [
                        _cache[46] || (_cache[46] = _createElementVNode("label", null, "\r\n\t\t\t\t\tFour Weeks Ohmic Rise Limit (%)\r\n\t\t\t\t", -1 /* CACHED */)),
                        _cache[47] || (_cache[47] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.fourWeeksOhmicRiseLimit,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.fourWeeksOhmicRiseLimit) = $event)),
                            modelModifiers: { trim: true },
                            min: "0",
                            max: "100",
                            step: "1"
                        }, null, 8 /* PROPS */, ["modelValue"])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[59] || (_cache[59] = _createTextVNode()),
        _createElementVNode("div", {
            class: _normalizeClass(['float-end', ',float-start-sm', _ctx.displayAdvancedFilter ? 'mt-3' : 'mt-5'])
        }, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _cache[52] || (_cache[52] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _cache[54] || (_cache[54] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.generateOhmicTrendReport
            }, {
                default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export PDF\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ], 2 /* CLASS */),
        _cache[60] || (_cache[60] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
